import { useTranslation } from 'next-i18next';
import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { slugify } from '@bridebook/toolbox/src';
import { useToggleBoolean } from '@bridebook/toolbox/src/utils/hooks/use-toggle-boolean';
import { Box, Collapse } from '@bridebook/ui';
import { IconApprove } from '@bridebook/ui/src/icons/dynamic';
import SectionHeading from '@bridebook/web/app-shared/components/supplier/sections/section-heading';
import msg, { MsgKey } from '@bridebook/web/app-shared/lib/supplier/msg';
import componentStyles from './section-v2.style';

type Details = ISupplier['typeDetails'][keyof ISupplier['typeDetails']];

interface IProps {
  section?: string[];
  name: string;
  last?: boolean;
  isMobile?: boolean;
  details: Details;
}

const ALTERED_HEADING_KEYS = ['ceremonyReception', 'foodDrink', 'details'];

const SectionV2: React.FC<IProps> = ({ section, name, isMobile, details }) => {
  const { t } = useTranslation('supplier');

  const [isSeeMoreOpen, , , toggleSeeMore] = useToggleBoolean(false);

  const hasSeeMore = section && section.length > 3;

  const renderFeature = (featureItem: string) => {
    const isOther = featureItem === 'other';
    const otherValue = isOther ? details?.[`${name}Other` as keyof typeof details] : '';
    const message = msg[featureItem as MsgKey]?.();
    if ((!isOther && !message) || (isOther && !otherValue)) {
      return;
    }
    return (
      <Box style={componentStyles.itemWrap} key={`sec-item-${slugify(featureItem)}`}>
        <Box style={componentStyles.iconWrap}>
          <IconApprove width={16} color="indigoCrush" />
        </Box>
        <Box style={componentStyles.text}>{(isOther ? otherValue : message) as string}</Box>
      </Box>
    );
  };

  const msgKey = (ALTERED_HEADING_KEYS.includes(name) ? `${name}_wedding` : name) as MsgKey;

  return (
    <Box style={componentStyles.wrapper}>
      <SectionHeading noMargin>{msg[msgKey]?.()}</SectionHeading>
      {isMobile ? (
        <Box style={componentStyles.itemSection}>
          {section && section.slice(0, 3).map((item) => renderFeature(item))}
          {hasSeeMore && (
            <>
              <Collapse isOpen={isSeeMoreOpen}>
                <Box>{section && section.slice(3).map((item) => renderFeature(item))}</Box>
              </Collapse>
              <Box as="a" onClick={toggleSeeMore} style={componentStyles.seeMoreLink}>
                {isSeeMoreOpen ? t('features.seeLess') : t('features.seeMore')}
              </Box>
            </>
          )}
        </Box>
      ) : (
        <Box style={componentStyles.itemSection}>
          {section && section.map((item) => renderFeature(item))}
        </Box>
      )}
    </Box>
  );
};

export default SectionV2;
